import React from 'react'

import LoadingSpinner from './LoadingSpinner'

export default () => (
  <div className='cover-without-background'>
    <LoadingSpinner />
  </div>
)
